import React, { useEffect, useMemo, useState } from "react"
import "./App.css"
import { CacheBusterProvider } from "./hooks/CacheBuster"
import { AlertProvider, useAlert } from "./hooks/useAlert"
import { AuthProvider, useAuth } from "./hooks/useAuth"
import { ProfileProvider, useProfile } from "./hooks/useProfile"
import Alert from "@mui/material/Alert"
import PrivateRoutes from "./routes/PrivateRoutes"
import PublicRoutes from "./routes/PublicRoutes"
import FullScreenLoader from "./components/FullScreenLoader"
import { MessagesProvider } from "./hooks/useMessages"
import { Collapse } from "@mui/material"
import { MessageStyles } from "./utils/styles"
import { ModalProvider, useModal } from "./hooks/useModal"
import { GetDatosProvider } from "./hooks/useGetDatos"
import { useSocket, SocketProvider } from "./hooks/useSockets"
import Modal from "./components/Modal"
import { syncChecklistsToServer, getPendingChecklists } from "./services/offlineSyncService"

const MS = MessageStyles()
const RootComponent = () => {
  const { session, sessionLoading, loginLoading } = useAuth()
  const { alertas, showAlert } = useAlert()
  const { socket } = useSocket()
  const [offlinePending, setOfflinePending] = useState(0)

  const MessageStyles = MS()

  useEffect(() => {
    const checkQueue = async () => {
      const pending = await getPendingChecklists();
      setOfflinePending(pending.length);
    };

    const handleOnline = async () => {

      showAlert({ message: "Conexión restaurada. Sincronizando checklists pendientes...", severity: "info" });
      const success = await syncChecklistsToServer();
      if (success) {
        showAlert({ message: "Sincronización completada exitosamente.", severity: "success" });
      }
      checkQueue();
    };

    const handleOffline = () => {
      showAlert({ message: "Se ha perdido la conexión. Trabajando en modo Offline.", severity: "warning" });
    };

    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);
    window.addEventListener("offline-queue-changed", checkQueue);

    checkQueue();

    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
      window.removeEventListener("offline-queue-changed", checkQueue);
    }
  }, []);

  const AlertMemo = useMemo(
    () => (
      <>
        {alertas.length > 0 && (
          <div className={MessageStyles.alert}>
            {alertas &&
              alertas.map((alerta, i) => {
                return (
                  <Collapse key={i} in={alerta.open}>
                    <Alert
                      style={{ margin: "10px" }}
                      severity={alerta.severity}
                      elevation={6}
                      variant="filled"
                    >
                      {alerta.message}
                    </Alert>
                  </Collapse>
                )
              })}
          </div>
        )}
      </>
    ),
    [alertas]
  )
  useEffect(() => {
    if (socket) {
      // Escuchar el evento 'notificacion' que enviamos desde el servidor
      socket.on("notificacion", (noti) => {
        // CAMBIADO DE "serverMessage" A "notificacion"
        let currentNotis = window.localStorage.getItem("notis")
          ? JSON.parse(window.localStorage.getItem("notis"))
          : []
        currentNotis = [...currentNotis, noti]
        window.localStorage.setItem("notis", JSON.stringify(currentNotis)) // Guardar en localStorage
        showAlert({ message: noti.title, severity: "success" })
      })

      // Limpiar el evento cuando el componente se desmonte
      return () => {
        socket.off("notificacion") // CAMBIADO DE "serverMessage" A "notificacion"
      }
    }
  }, [socket])

  if (sessionLoading) return <FullScreenLoader />

  return (
    <>
      <Modal />
      {!session ? (
        <PublicRoutes />
      ) : !loginLoading ? (
        <PrivateRoutes />
      ) : (
        <FullScreenLoader />
      )}
      {AlertMemo}
    </>
  )
}

function App() {
  return (
    <CacheBusterProvider>
      <AlertProvider>
        <MessagesProvider>
          <SocketProvider>
            <ModalProvider>
              <ProfileProvider>
                <AuthProvider>
                  <GetDatosProvider>
                    <RootComponent />
                  </GetDatosProvider>
                </AuthProvider>
              </ProfileProvider>
            </ModalProvider>
          </SocketProvider>
        </MessagesProvider>
      </AlertProvider>
    </CacheBusterProvider>
  )
}

export default App
